
import React from 'react';
import './FloatingIcons.css';
import { Link } from 'react-router-dom';

// Placeholder icons - in a real app, these would be SVG or image components
const Icon = ({ children }) => <div className="icon-placeholder">{children}</div>;

function FloatingIcons() {
  return (
    <div className="floating-icons-container">
      <Link to="/games" className="floating-icon icon-games"><Icon>🎮</Icon><span>Games</span></Link>
      <a href="https://thrillartsTattoos.com/" className="floating-icon icon-tattoos"><Icon>🎨</Icon><span>Tattoos</span></a>
      <a href="https://thrillartspost.com/" className="floating-icon icon-social"><Icon>🌐</Icon><span>Social Site</span></a>
      <Link to="/paintings" className="floating-icon icon-paintings"><Icon>🖼️</Icon><span>Paintings</span></Link>
      <a href="https://thrillartsMusic.com" className="floating-icon icon-music"><Icon>🎵</Icon><span>Music</span></a>
      <Link to="/fashion" className="floating-icon icon-fashion"><Icon>👗</Icon><span>Fashion</span></Link>
      <a href="https://ThrillArtsAI.com" className="floating-icon icon-ai"><Icon>🤖</Icon><span>A.I.</span></a>
      <Link to="/virtual-tours" className="floating-icon icon-virtual-tours"><Icon>🏠</Icon><span>Virtual Tours</span></Link>
      <Link to="/animation" className="floating-icon icon-animation"><Icon>🎬</Icon><span>Animation</span></Link>
      <Link to="/products" className="floating-icon icon-products"><Icon>📦</Icon><span>Products</span></Link>
    </div>
  );
}

export default FloatingIcons;
